module.exports = __webpack_public_path__ + "static/ey-2-sq-77f2e67fb843dae57504f0a17388990c.png";